import styled from 'styled-components'
import Checkbox, { CHECKBOX_DIRECTIONS, CheckboxSubLabel } from './Checkbox.jsx'

const CheckboxGroupWrapper = styled.fieldset`
  display: flex;
  flex-direction: column;
  padding: 0px;
  position: relative;
  border: 0px;
  margin: 0px;
  ${({ direction }) =>
    direction === CHECKBOX_DIRECTIONS.RIGHT
      ? `/* DIRECTION: RIGHT */
        width: auto; 
        align-items: stretch;`
      : `/* DIRECTION: LEFT */
        width: fit-content; 
        align-items: start;`}
`

/**
 * @param {Object} props
 * @param {'left' | 'right'} [props.direction]
 * @param {boolean} [props.disabled]
 * @param {Function} props.register
 * @param {string} props.name
 * @param {Object} [props.registerOptions]
 * @param {Object} props.errors
 * @param {string} [props.helpText]
 * @param {Array<{ value: string, label: any }>} props.options
 */
const CheckboxGroup = ({
  direction = CHECKBOX_DIRECTIONS.LEFT,
  disabled,
  register,
  name,
  registerOptions,
  errors,
  helpText,
  options,
  className
}) => {
  return (
    <div>
      <CheckboxGroupWrapper direction={direction} className={className}>
        {options.map((option, index) => {
          return (
            <Checkbox
              disabled={disabled}
              key={`${name}${index}`}
              value={option.value}
              label={option.label}
              errors={errors}
              {...register(name, registerOptions)}
              direction={direction}
              isPartOfGroup={true}
            />
          )
        })}
      </CheckboxGroupWrapper>
      {(helpText || Boolean(errors)) && (
        <CheckboxSubLabel
          errors={errors}
          name={name}
          disabled={disabled}
          direction={direction}
          label={helpText}
        />
      )}
    </div>
  )
}

export default CheckboxGroup
